@if (isOrderHistoryList) {
  <div class="cx-order-overview-summary border-dark p-0">
    <div class="">
      @if (order.replenishmentOrderCode) {
        <div class="cx-summary-card">
          <cx-card [content]="getReplenishmentCodeCardContent(order?.replenishmentOrderCode) | async"></cx-card>
          @if (order?.created) {
            <cx-card [content]="getOrderCurrentDateCardContent() | async"></cx-card>
          }
          <cx-card [content]="getReplenishmentActiveCardContent(order?.active) | async"></cx-card>
        </div>
        <div class="cx-summary-card">
          <cx-card [content]="getReplenishmentStartOnCardContent(order?.firstDate) | async"></cx-card>
          <cx-card [content]="getReplenishmentFrequencyCardContent(order?.trigger?.displayTimeTable) | async"></cx-card>
          <cx-card [content]="getReplenishmentNextDateCardContent(order?.trigger?.activationTime)| async"></cx-card>
        </div>
      } @else {
        <div class="row">
          <div class="col-12">
            <div class="cx-order-overview-card border border-dark mb-4">
              <div class="col-lg-7 card-content p-0">
                <cx-card [content]="getCarrierNameCardContent(order?.carrierName) | async" [border]="false"></cx-card>
                <cx-card [content]="getCarrierIdentifierCardContent(order?.transportExpedition) | async"
                [border]="false"></cx-card>
                <div class="card-body">
                  <div class="cx-card-container">
                    <div class="cx-card-label-container">
                      <div class="cx-card-label-bold">
                        {{'paymentTypes.title' | cxTranslate}}
                      </div>
                      <div class="cx-card-content">
                        {{'paymentTypes.paymentType_'+order?.paymentMode?.code | cxTranslate}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              @if (order?.carrierUrl) {
                <div class="col-lg-5 card-actions-container align-items-md-end">
                  <a href="{{order?.carrierUrl}}" target="_blank" type="button"
                    class="btn btn-black btn-with-icon btn-direccion">
                    <app-custom-icons [type]="iconType.ICON_DIRECCION">&nbsp;</app-custom-icons>
                    {{'orderDetails.consignmentTracking.action' | cxTranslate}}
                  </a>
                </div>
              }
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="cx-order-overview-card border border-dark mb-4">
              <cx-card [content]="getAddressCardContent(order?.deliveryAddress) | async " [border]="false"></cx-card>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="cx-order-overview-card border border-dark mb-4">
              <cx-card [content]="getBillingAddressCardContent(order?.billingAddress) | async"
              [border]="false"></cx-card>
            </div>
          </div>
        </div>
      }
      <!--            <ng-container *ngIf="order.purchaseOrderNumber || order.purchaseOrderNumber === ''">-->
      <!--                <div class="cx-summary-card">-->
      <!--                    <cx-card [content]="getPurchaseOrderNumber(order?.purchaseOrderNumber) | async"></cx-card>-->
      <!--                    <cx-card [content]="getMethodOfPaymentCardContent(order.paymentInfo) | async"></cx-card>-->
      <!--                    <ng-container *ngIf="order.costCenter">-->
      <!--                        <cx-card [content]="getCostCenterCardContent(order?.costCenter) | async"></cx-card>-->
    <!--                    </ng-container>-->
  <!--                </div>-->
<!--            </ng-container>-->
<!--            <div class="cx-summary-card">-->
<!--                <ng-container *ngIf="order.deliveryAddress">-->
<!--                    <cx-card [content]="getAddressCardContent(order?.deliveryAddress) | async"></cx-card>-->
<!--                </ng-container>-->
<!--                <ng-container *ngIf="order.deliveryMode">-->
<!--                    <cx-card [content]="getDeliveryModeCardContent(order?.deliveryMode) | async"></cx-card>-->
<!--                </ng-container>-->
<!--            </div>-->
<!--            <ng-container *ngIf="order.paymentInfo">-->
<!--                <div class="cx-summary-card">-->
<!--                    <cx-card [content]="getPaymentInfoCardContent(order?.paymentInfo) | async"></cx-card>-->
<!--                    <cx-card-->
<!--                            [content]="getBillingAddressCardContent(order?.paymentInfo?.billingAddress) | async"></cx-card>-->
<!--                </div>-->
<!--            </ng-container>-->
</div>
</div>
} @else {
  <!--    <div class="cx-order-summary">-->
  <!--        <div class="container">-->
  <!--            <ng-container *ngIf="order.replenishmentOrderCode; else otherOrder">-->
  <!--                <div class="cx-summary-card">-->
  <!--                    <cx-card-->
  <!--                            [content]="-->
  <!--            getReplenishmentCodeCardContent(order?.replenishmentOrderCode)-->
  <!--              | async-->
  <!--          "-->
  <!--                    ></cx-card>-->

  <!--                    <ng-container *ngIf="order?.created">-->
  <!--                        <cx-card-->
  <!--                                [content]="getOrderCurrentDateCardContent() | async"-->
  <!--                        ></cx-card>-->
  <!--                    </ng-container>-->

  <!--                    <cx-card-->
  <!--                            [content]="getReplenishmentActiveCardContent(order?.active) | async"-->
  <!--                    ></cx-card>-->
  <!--                </div>-->

  <!--                <div class="cx-summary-card">-->
  <!--                    <cx-card-->
  <!--                            [content]="-->
  <!--            getReplenishmentStartOnCardContent(order?.firstDate) | async-->
  <!--          "-->
  <!--                    ></cx-card>-->

  <!--                    <cx-card-->
  <!--                            [content]="-->
  <!--            getReplenishmentFrequencyCardContent(-->
  <!--              order?.trigger?.displayTimeTable-->
  <!--            ) | async-->
  <!--          "-->
  <!--                    ></cx-card>-->

  <!--                    <cx-card-->
  <!--                            [content]="-->
  <!--            getReplenishmentNextDateCardContent(order?.trigger?.activationTime)-->
  <!--              | async-->
  <!--          "-->
  <!--                    ></cx-card>-->
  <!--                </div>-->
  <!--            </ng-container>-->

  <!--            <ng-template #otherOrder>-->
  <!--                <div class="cx-summary-card">-->
  <!--                    <cx-card-->
  <!--                            [content]="getOrderCodeCardContent(order?.code) | async"-->
  <!--                    ></cx-card>-->

  <!--                    <cx-card-->
  <!--                            [content]="getOrderCurrentDateCardContent(order?.created) | async"-->
  <!--                    ></cx-card>-->

  <!--                    <cx-card-->
  <!--                            [content]="getOrderStatusCardContent(order.statusDisplay) | async"-->
  <!--                    ></cx-card>-->
  <!--                </div>-->
  <!--            </ng-template>-->

  <!--            <ng-container-->
  <!--                    *ngIf="order.purchaseOrderNumber || order.purchaseOrderNumber === ''"-->
  <!--            >-->
  <!--                <div class="cx-summary-card">-->
  <!--                    <cx-card-->
  <!--                            [content]="getPurchaseOrderNumber(order?.purchaseOrderNumber) | async"-->
  <!--                    ></cx-card>-->

  <!--                    <cx-card-->
  <!--                            [content]="getMethodOfPaymentCardContent(order.paymentInfo) | async"-->
  <!--                    ></cx-card>-->

  <!--                    <ng-container *ngIf="order.costCenter">-->
  <!--                        <cx-card-->
  <!--                                [content]="getCostCenterCardContent(order?.costCenter) | async"-->
  <!--                        ></cx-card>-->
  <!--                    </ng-container>-->
  <!--                </div>-->
  <!--            </ng-container>-->

  <!--            <div class="cx-summary-card">-->
  <!--                <ng-container *ngIf="order.deliveryAddress">-->
  <!--                    <cx-card-->
  <!--                            [content]="getAddressCardContent(order?.deliveryAddress) | async"-->
  <!--                    ></cx-card>-->
  <!--                </ng-container>-->

  <!--                <ng-container *ngIf="order.deliveryMode">-->
  <!--                    <cx-card-->
  <!--                            [content]="getDeliveryModeCardContent(order?.deliveryMode) | async"-->
  <!--                    ></cx-card>-->
  <!--                </ng-container>-->
  <!--            </div>-->

  <!--            <ng-container *ngIf="order.paymentInfo">-->
  <!--                <div class="cx-summary-card">-->
  <!--                    <cx-card-->
  <!--                            [content]="getPaymentInfoCardContent(order?.paymentInfo) | async"-->
  <!--                    ></cx-card>-->

  <!--                    <cx-card-->
  <!--                            [content]="-->
  <!--            getBillingAddressCardContent(order?.paymentInfo?.billingAddress)-->
  <!--              | async-->
  <!--          "-->
  <!--                    ></cx-card>-->
  <!--                </div>-->
  <!--            </ng-container>-->
  <!--        </div>-->
  <!--    </div>-->

}
